export const BUTLER_POWER_UP_ID = '5935cab6b26816f9d49fd814';
export const BUTLER_APPLICATION_ID = '56ff07afbc287582d36e19ac';